import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { I18nextProvider, useTranslation } from 'react-i18next';
import { ThemeProvider, StyledEngineProvider, CssBaseline } from '@mui/material';
import { BrowserRouter as Router } from 'react-router-dom';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import StoreConfig from './Config/store.config';
import i18n from './Config/i18n.config';
import NeoTheme from './Config/theme.config';
import RootContainer from './Root.container';
import NeoSnackbarProvider from './Components/NeoSnackprovider/NeoSnackbarProvider';
import { CookiesProvider } from 'react-cookie';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Helmet } from 'react-helmet';

const App = () => {
  const queryClient = new QueryClient();
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>{t('SEO.general.title')}</title>
        <meta name="description" content={t('SEO.general.description')} />
      </Helmet>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={NeoTheme}>
          <QueryClientProvider client={queryClient}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <CssBaseline />
              <I18nextProvider i18n={i18n}>
                <CookiesProvider>
                  <Provider store={StoreConfig.store}>
                    <NeoSnackbarProvider maxSnack={3}>
                      <PersistGate loading={null} persistor={StoreConfig.persistor}>
                        <Router getUserConfirmation={() => {}}>
                          <RootContainer />
                        </Router>
                      </PersistGate>
                    </NeoSnackbarProvider>
                  </Provider>
                </CookiesProvider>
              </I18nextProvider>
            </LocalizationProvider>
          </QueryClientProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </>
  );
};
export default App;
